function branchMessageOptionAndChildBranchConditionMismatchCheck(config) {
    function checkJsonErrors(json) {
        const errors = [];

        // Extract option from condition assuming pattern ^option\\b, excluding .*
        function extractCondition(condition) {
            const match = condition.match(/\^(.*?)\\b/)
            return match ? match[1] : ''
        }

        function extractOptions(message) {
            //const optionRegex = /\b([A-Za-z]|\d+)\s*[\.\)\-\:\,\s]\s*/g;
            // Regex to match alphanumeric options at the start of a new line followed by specific separators or single characters followed by a space
            // "A. ", "1A) ", "ABC - ", "123: ", but "E " (only single char if space is separator)
            const optionRegex = /^(?:([A-Za-z0-9]+)(?=[\.\)\-\:])|([A-Za-z0-9])(?=\s))/gm
            const matches = [];
            let match

            while ((match = optionRegex.exec(message)) !== null) {
                // Choose the appropriate capturing group
                const option = match[1] ? match[1] : match[2]
                matches.push(option.trim().toUpperCase())
            }

            return matches

        }

        const optionMissingFromMessageErrors = []
        const childBranchMissingErrors = []

        function checkBranchForMismatch(branch) {
            // Define possible options from message text, and the options from conditions that child branches have
            const messageOptions = extractOptions(branch === "initial" ? json?.message : json[branch]?.message || "")
            const childBranchOptions = []
            for (const key in json) {
                if ((branch === "initial" ? json[key]?.parent === null : json[key]?.parent === branch) && key.startsWith("branch") && json[key]?.condition !== ".*") {
                    const childBranchOption = extractCondition(json[key]?.condition || "").toUpperCase()
                    childBranchOptions.push(childBranchOption)
                }
            }
            // Check if branch message answer options include child branch conditions
            for (const option of childBranchOptions) {
                if (!messageOptions.includes(option)){
                    const errorObject = {
                        "branch" : branch,
                        "option" : option
                    }
                    optionMissingFromMessageErrors.push(errorObject)
                }
            }
            // Check if all branch message answer options have a child branch with matching condition
            for (const option of messageOptions) {
                if (!childBranchOptions.includes(option)) {
                    const errorObject = {
                        "branch" : branch,
                        "option" : option
                    }
                    childBranchMissingErrors.push(errorObject)
                }
            }
        }

        // Check initial message
       checkBranchForMismatch("initial")

        // Check all branches
        for (const key in json) {
            if (key.startsWith("branch")) {
                checkBranchForMismatch(key)
            }
        }

        const errorObject = {
            missingChildErrors : childBranchMissingErrors,
            missingOptionsErrors : optionMissingFromMessageErrors
        }

        return errorObject
    }

    const errors = checkJsonErrors(config)

    return errors
}

export function checkSurveyDataForBranchErrors(data) {
    const config = data?.config
    if (config) {
        return branchMessageOptionAndChildBranchConditionMismatchCheck(config)
    }
    return []
}

export function getErrorsByBranch(errorObject, branchName) {
    const errors = {
        missingChildErrors: [],
        missingOptionsErrors: []
    }

    if (errorObject.missingChildErrors && errorObject.missingChildErrors.length) {
        errors.missingChildErrors = errorObject.missingChildErrors.filter(error => error.branch === branchName)
    }

    if (errorObject.missingOptionsErrors && errorObject.missingOptionsErrors.length) {
        errors.missingOptionsErrors = errorObject.missingOptionsErrors.filter(error => error.branch === branchName)
    }

    return errors
}